<template>
  <div class="po-payment" style="width:780px;margin:0 auto;background-color:#fff;">
    <div style="text-align:center;margin-top:20px;font-size:20px;">PO <a @click="view">CYS{{ $route.params.id }}</a></div>
    <div style="text-align:center;margin-top:10px;">Payment Date:
      <el-date-picker v-model="form.payment_date" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions" style="width:150px;"></el-date-picker>
      <el-button @click="setToday">Today</el-button>
      <el-button @click="setYesterday">Yesterday</el-button>
    </div>
    <table style="margin-top:20px;">
      <tr>
        <td style="width:100px;font-weight:bold;">Status</td>
        <td style="width:100px;">Payment:</td>
        <td>
          <select v-model="form.currency" style="width:80px;">
            <option>USD</option>
            <option>HKD</option>
            <option>RMB</option>
          </select>
          Amount:
          <el-input v-model.number="form.payment_amount" class="input-number" style="width:80px;"></el-input>
          Remark:
          <el-input v-model="form.payment_remark" style="width:200px;"></el-input>
        </td>
      </tr>
      <tr>
        <td rowspan="4" style="font-weight:bold;">Charges</td>
        <td>Shipping:</td>
        <td>
          <select v-model="form.currency" style="width:80px;">
            <option>USD</option>
            <option>HKD</option>
            <option>RMB</option>
          </select>
          Amount:
          <el-input v-model.number="form.shipping_amount" class="input-number" style="width:80px;"></el-input>
          Remark:
          <el-input v-model="form.shipping_remark" style="width:200px;"></el-input>
        </td>
      </tr>
      <tr>
        <td>Bank:</td>
        <td>
          <select v-model="form.currency" style="width:80px;">
            <option>USD</option>
            <option>HKD</option>
            <option>RMB</option>
          </select>
          Amount:
          <el-input v-model.number="form.bank_amount" class="input-number" style="width:80px;"></el-input>
          Remark:
          <el-input v-model="form.bank_remark" style="width:200px;"></el-input>
        </td>
      </tr>
      <tr>
        <td>E Reach:</td>
        <td>
          <select v-model="form.currency" style="width:80px;">
            <option>USD</option>
            <option>HKD</option>
            <option>RMB</option>
          </select>
          Amount:
          <el-input v-model.number="form.ereach_amount" class="input-number" style="width:80px;"></el-input>
          Remark:
          <el-input v-model="form.ereach_remark" style="width:200px;"></el-input>
        </td>
      </tr>
      <tr>
        <td>Other:</td>
        <td>
          <select v-model="form.currency" style="width:80px;">
            <option>USD</option>
            <option>HKD</option>
            <option>RMB</option>
          </select>
          Amount:
          <el-input v-model.number="form.other_amount" class="input-number" style="width:80px;"></el-input>
          Remark:
          <el-input v-model="form.other_remark" style="width:200px;"></el-input>
        </td>
      </tr>
    </table>
    <div style="margin-top:20px;">
      <el-button type="primary" @click="save">Save</el-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      form: {
        id: 0,
        doc_id: this.$route.params.id,
        payment_date: null,
        currency: 'USD',
        payment_amount: 0,
        shipping_amount: 0,
        bank_amount: 0,
        ereach_amount: 0,
        other_amount: 0,
        payment_remark: '',
        shipping_remark: '',
        bank_remark: '',
        ereach_remark: '',
        other_remark: ''
      },
      pickerOptions: {
        shortcuts: [{
          text: 'today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'yesterday',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'a week ago',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      }
    }
  },
  mounted () {
    this.fetchPayment()
  },
  methods: {
    fetchPayment () {
      this.$http.get('/dbapi/po_payment?doc_id=' + this.$route.params.id).then(data => {
        if (data.list.length > 0) {
          this.form = data.list[0]
        }
      })
    },
    setToday () {
      this.form.payment_date = moment().format('YYYY-MM-DD')
    },
    setYesterday () {
      let date = new Date()
      date.setTime(date.getTime() - 3600 * 1000 * 24)
      this.form.payment_date = moment(date).format('YYYY-MM-DD')
    },
    save () {
      let url = '/dbapi/po_payment_update'
      if (this.form.id === 0) {
        url = '/dbapi/po_payment_insert'
      }
      this.$http.post(url, this.form).then(data => {
        this.$close()
      })
    },
    view () {
      window.open(`/po-doc-view/${this.$route.params.id}`, `po-doc-view`, 'height=750,width=800,top=50,left=200,toolbar=yes,menubar=yes,scrollbars=no,resizable=yes,location=no,status=no')
    }
  }
}
</script>

<style>
.po-payment table {
  width: 100%;
  border-top: 1px solid #999;
  border-left: 1px solid #999;
  border-spacing: 0;
}
.po-payment table th,.po-payment table td {
  padding: 4px;
  border-right: 1px solid #999;
  border-bottom: 1px solid #999;
}
</style>


